export class Tag {
    constructor(json) {
        this.id = json.id;
        this.category = json.category;
        this.value = json.value;
        this.displayString = this.category
            ? `${this.category}:${this.value}`
            : this.value;
    }
}
//# sourceMappingURL=Tag.js.map